module.exports = __webpack_public_path__ + "static/img/sign-a.5128573f.png";